import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Nuevo extends Component {
  render() {
    return (
        <div className="w3-container">
            <h5>Nuevo Correo</h5>
            <div className="w3-container w3-white w3-card w3-padding">
                <div className="w3-half w3-padding">
                    <label className="w3-text-grey" htmlFor='cliente'>cliente</label>
                    <input className="w3-input w3-border" type="text" id='cliente' />
                </div>
                <div className="w3-container w3-padding">
                    <label className="w3-text-grey" htmlFor='asunto'>Asunto</label>
                    <input className="w3-input w3-border" type="text" id='asunto' />
                </div>
                <div className="w3-container w3-padding">
                    <label className="w3-text-grey" htmlFor='descripcion'>Descripción</label>
                    <textarea className="w3-input w3-border" id='descripcion'></textarea>
                </div>
                <div className='w3-center w3-container w3-margin' style={{marginTop: '25px'}}>
                    <button className="w3-button w3-black w3-round">Enviar</button>
                    <Link to={`/correos`} style={{marginLeft: '10px'}} className="w3-button w3-black w3-round">Cancelar</Link>
                </div>
            </div> 
        </div>
    );
  }
}

export default Nuevo;


// WEBPACK FOOTER //
// ./src/Correo/New.js